/**
 * ICD-10-CM codes F01–F99: Mental, Behavioral and Neurodevelopmental disorders.
 * Full list is stored in src/data/icd10-f01-f99.json (reference: https://www.icd10data.com/ICD10CM/Codes/F01-F99).
 * Used for Treatment Plan template default diagnosis in the Template Builder.
 * To refresh the list from the CDC or icd10data.com, run from `medplum-ui`: `cd ../medplum-server && npx tsx scripts/fetch-icd10-f01-f99.ts` (if the source allows).
 */
import icd10Json from '../../../../data/icd10-f01-f99.json';

export interface Icd10Entry {
  code: string;
  description: string;
}

/** ICD-10-CM F01–F99: Mental, Behavioral and Neurodevelopmental disorders. Loaded from application data. */
export const ICD10_MENTAL_BEHAVIORAL: Icd10Entry[] = icd10Json as Icd10Entry[];

/** Get description for an ICD-10 code, or undefined if not found. */
export function getIcd10Description(code: string): string | undefined {
  if (!code?.trim()) return undefined;
  const normalized = code.trim();
  const entry = ICD10_MENTAL_BEHAVIORAL.find(
    (e) => e.code === normalized || e.code === normalized.toUpperCase(),
  );
  return entry?.description;
}
